import { createQueryKeys } from "@lukemorales/query-key-factory";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import { IDropdownModel } from "common/models/IDropdownModel";
import { PostModel } from "common/models/BaseModel";
import { IListResponse } from "common/models/GridModels";
import { languageView } from "../types/languageView";
import { ILanguage, ILanguageGridFilter, ILanguageGridModel } from "./types";

export const language = createQueryKeys("language", {
  list: (postModel: PostModel<ILanguageGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<IListResponse<ILanguageGridModel>>(
        endpoints.language.list,
        postModel
      ),
  }),

  getById: (Id?: string | null) => ({
    queryKey: [Id],
    queryFn: () => api.get<ILanguage>(`${endpoints.language.getById}/${Id}`),
  }),

  getLanguageValues: () => ({
    queryKey: ["GetLanguageValues"],
    queryFn: () =>
      api.get<IDropdownModel[]>(endpoints.language.getLanguageValues),
  }),

  getViewById: (Id?: string | null) => ({
    queryKey: ["modal", Id],
    queryFn: () => api.get<languageView>(`${endpoints.language.view}/${Id}`),
  }),
});
